<!-- AI的完整分析过程 -->
<template>
  <transition name="dialog-fade">
    <div class="dialog-wrapper" v-if="visible" @click.self="close">
      <transition name="dialog-scale">
        <dl class="dialog" v-if="visible" v-loading="loading">
          <dt class="dialog-title">
            <strong>AI建议完整分析过程</strong>
            <span class="close" @click="close">关闭</span>
          </dt>
          <dd class="dialog-body">
            <!--
            <div class="answer">
              <div class="body">
                <div v-html="html" class="ai-answer"></div>
              </div>
            </div>
            -->
            <div class="messages">
              <Chat :record="record" field="deepThink" />
            </div>
          </dd>
          <dd class="dialog-footer" v-if="false">
            <button @click="close" class="cancel">取消</button>
          </dd>
        </dl>
      </transition>
    </div>
  </transition>
</template>

<script>
import Chat from './Chat.vue';

export default {
  name: 'Dialog',
  components: {
    Chat,
  },
  data() {
    return {
      html: null,
      visible: false,
      loading: false,
    };
  },
  methods: {
    close() {
      let self = this;
      self.visible = false;
      self.$emit('close');
    },
    show(record) {
      let self = this;
      self.visible = true;
      // const html =
      //   record &&
      //   record.deepThink &&
      //   record.deepThink
      //     .split(/\n\s*\n/)
      //     .filter(Boolean) // 过滤掉数组中的空字符串
      //     .map((v) => `<p>${v}</p>`)
      //     .join('\n');
      // console.log('完整分析过程', { ...record });
      // self.html = html;
      self.record = record;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
@mixin linearText($from: #ffffff, $to: #5fde8c, $fromOffset: 0%, $toOffset: 100%) {
  color: $from;
  background: linear-gradient(to bottom, $from $fromOffset, $to $toOffset);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
%scrollbar {
  overflow: auto;

  &::-webkit-scrollbar {
    width: vh(6);
    height: vh(6);
  }

  &::-webkit-scrollbar-track {
    // background: rgba(10, 77, 19, 0.2);
    background: transparent;
    border-radius: vh(2);
  }

  &::-webkit-scrollbar-thumb {
    background: #00af6f;
    border-radius: vh(20);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(48, 234, 168, 0.8);
  }

  &::-webkit-scrollbar-corner {
    background: rgba(48, 234, 168, 0.6);
  }
}
.dialog-wrapper {
  // 注释原因：当前子对话框出现时父对话框内容隐藏但遮罩未藏，双遮罩颜色过深，所以去除当前的
  background-color: transparent !important;
  backdrop-filter: none !important;
}
.dialog {
  padding: 0;
  .dialog-title {
    background: linear-gradient(90deg, rgba(2, 79, 48, 0.8) 0%, rgba(2, 79, 48, 0.3) 100%);
    height: vh(33);
    line-height: vh(33);
    strong {
      font-size: fontSize(18);
      font-weight: bold;
      font-style: italic;
      padding: 0 0.5em;
      @include linearText(#fff, #5fde8c, 0%, 100%);
    }
  }
  .dialog-body {
    padding: vh(32) vw(34);
  }
}
.messages {
  height: vh(835);
}
// .answer {
//   margin: 0;
//   .body {
//     background: #00250d;
//     padding: vh(17) vw(17);
//     font-size: fontSize(16);
//     line-height: 1.8;
//     // min-height: vh(300);
//     // max-height: vh(555);
//     height: vh(565);
//     overflow: auto;
//     @extend %scrollbar;
//   }
// }
</style>
